import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { editFlowRunTaskDialog } from '~src/flow/utils/FlowDialogUtils';
import { editLinkedTaskDialog } from '~src/linkedTasks/components/EditLinkedTaskDialog';
import { LinkedTasks } from '~src/linkedTasks/resources/LinkedTasks';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { RunFlowTaskChangePriority, RunFlowTaskChangeSchedule, RunFlowTaskEditTask,RunFlowTaskResume, RunFlowTaskRunNow } from '../../app/actions/AppActionTypes';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { Set } from '../../ts/models/Set';
import { ChangeScheduleActionService } from '../../ts/services/ChangeScheduleAction';
import { ChangeRunFlowTasksPriorityAction } from '../actions/ChangeRunFlowTasksPriorityAction';
import { showResumeRunFlowTasksActionDialog } from '../actions/ResumeRunFlowTasksAction';
import { RunFlowTaskMenuAction } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTasksAction } from '../actions/RunFlowTasksAction';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';

export function* handleRunNow(action: RunFlowTaskMenuAction) {
  try {
    yield call(runNow, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function runNow(runFlowTasks: RunFlowTaskInfo[]) {
  return RunFlowTasksAction.dialog(Set.fromIdItemArray(runFlowTasks));
}

export function* handleEditTask(action: RunFlowTaskMenuAction) {
  try {
    yield call(editTask, action.items);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function editTask(runFlowTasks: RunFlowTaskInfo[]) {
  const task = runFlowTasks[0]; // We expect only a single task
  if (task.taskType === 'LinkedTask') {
    LinkedTasks.getLinkedTask(task.linkedTaskId).then(response => {
      editLinkedTaskDialog(response);
    });
  } else {
    editFlowRunTaskDialog(task);
  }
}

export function* handleChangeSchedule(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(changeSchedule, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function changeSchedule(runFlowTasks: RunFlowTaskInfo[]) {
  return ChangeScheduleActionService.forRunFlowTasks(Set.fromIdItemArray(runFlowTasks));
}

export function* handleChangePriority(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(changePriority, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function changePriority(runFlowTasks: RunFlowTaskInfo[]) {
  return ChangeRunFlowTasksPriorityAction.dialog(Set.fromIdItemArray(runFlowTasks));
}

export function* handleResume(action: RunFlowTaskMenuAction): SagaIterator {
  try {
    yield call(resume, action.items);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function resume(runFlowTasks: RunFlowTaskInfo[]) {
  return showResumeRunFlowTasksActionDialog(Set.fromIdItemArray(runFlowTasks));
}

export function* rootRunFlowTaskMenuActionSaga(): SagaIterator {
  yield takeEvery(RunFlowTaskRunNow, handleRunNow);
  yield takeEvery(RunFlowTaskEditTask, handleEditTask);
  yield takeEvery(RunFlowTaskChangeSchedule, handleChangeSchedule);
  yield takeEvery(RunFlowTaskChangePriority, handleChangePriority);
  yield takeEvery(RunFlowTaskResume, handleResume);
}
